import { Storage } from "utils/storage";

import { FrictionBreakdownView } from "./frictionBreakdownData";

export const FRICTION_BREAKDOWN_VIEWS = [
    "all",
    "overdue",
    "rejected",
    "reopened",
] as const satisfies readonly FrictionBreakdownView[];

export type SupportedFrictionBreakdownView =
    (typeof FRICTION_BREAKDOWN_VIEWS)[number];

export const frictionBreakdownStorage = new Storage<
    "localStorage",
    "controlHealth",
    "frictionBreakdownView",
    SupportedFrictionBreakdownView
>({
    type: "localStorage",
    namespace: "controlHealth",
    codecs: {
        encodeKey: (key) => key,
        encodeValue: (value) => value,
        decodeValue: (value) =>
            FRICTION_BREAKDOWN_VIEWS.find((view) => view === value) ?? "all",
    },
});
